import React, { MutableRefObject, useRef } from 'react';
import { Parallax, ParallaxLayer, IParallax } from '@react-spring/parallax';
import CatGif from 'src/pages/Design/pages/CatParachuteParallax/assets/cat.gif';
import LandPng from 'src/pages/Design/pages/CatParachuteParallax/assets/land.png';
import MoonPng from 'src/pages/Design/pages/CatParachuteParallax/assets/moon.png';

const CatParachuteParallax: React.FC = () => {
  const ref = useRef<IParallax>(null);
  return (
    <>
      <Parallax
        pages={4}
        ref={ref}
      >
        {/* sets up the background */}
        <ParallaxLayer
          // describes what page it will start on
          offset={0}
          // indicates how fast it will be moving
          speed={1}
          // indicates a factor 
          // TODO: still need to look into this
          factor={4}
          style={{
            backgroundImage: `url(${MoonPng})`,
            backgroundSize: 'cover',
          }}
        />

        <ParallaxLayer
          offset={2}
          speed={1}
          factor={4}
          style={{
            backgroundImage: `url(${LandPng})`,
            backgroundSize: 'cover',
          }}
        />

        {/* sets up the "floating" cat */}
        <ParallaxLayer
          sticky={{ start: 0.6, end: 3.7 }}
          style={{ textAlign: 'center' }}
        >
          <img
            src={CatGif}
            alt=''
          />
        </ParallaxLayer>

        {/* sets up the text overlayed onto the backgrounds */}
        <ParallaxLayer
          offset={0.4}
          speed={0.05}
          style={{ textAlign: 'center' }}
          onClick={() => {
            if (ref !== null && ref.current !== null) ref.current.scrollTo(3);
          }}
        >
          <h1 style={{ color: 'white' }}>Welcome to my parallax website</h1>
        </ParallaxLayer>

        <ParallaxLayer
          offset={3.6}
          speed={2}
          style={{ textAlign: 'center' }}
          onClick={() => {
            console.log(ref);
            if (ref !== null && ref.current !== null) ref.current.scrollTo(0);
          }}
        >
          <h1 style={{ color: 'white' }}>Thanks for Coming!!</h1>
        </ParallaxLayer>
      </Parallax>
    </>
  );
};

export default CatParachuteParallax;
